import React, {useState, useEffect} from 'react';
import { createTheme, createStyles, ThemeProvider, Theme, withStyles, makeStyles } from '@material-ui/core/styles';
import {useSelector, useDispatch } from 'react-redux';
import {IntlProvider, FormattedMessage} from 'react-intl';
import GlobalActions from 'stores/global/actions';
import _ from 'lodash';
import { 
  Box,
  Icon
 } from '@material-ui/core';
import Alert, { Color} from '@material-ui/lab/Alert';
import BasicTheme from 'themes'; 

export interface AlertProps {
  configName?:string;
  themeName?:string;
  options?: AlertOptions,
  previewTheme?: Theme
}

export interface AlertOptions {
  visible: boolean;
  position?: 'fixed' | 'relative' | 'absolute' | 'initial';
  severity: Color;
  variant?: 'standard' | 'filled' | 'outlined';
  Icon?: React.ReactNode;
  close?: boolean;
  closeAction?():void | null | undefined;
  vertical?: 'top' | 'bottom';
  top?: number | undefined;
  bottom?: number | undefined;
  content?: string | React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      left: 0,
      zIndex: theme.zIndex['modal'],
    },
  }),
);

const LBAlert = (props:AlertProps) => {
  const {configName, themeName, options, previewTheme} = props;
  const dispatch = useDispatch();
  const global = useSelector( (state:any) => state.global);
  const alertSetting:AlertOptions = options || global.alert;
  const [loaded, setLoaded] = useState(false)
  const componentConfig = require(`./${configName || 'config'}.json`);
  const componentTheme = require(`./${themeName || 'theme'}.json`);
  
  const classes = useStyles();
  const [visible, setVisible] = useState(false)
  const defaultTheme = createTheme(_.defaultsDeep(componentTheme,BasicTheme))

  const theme:any = createTheme(_.defaultsDeep({
    overrides: {
     
    }
  }, previewTheme || defaultTheme));

  useEffect(() => {
    if(!options && loaded && !visible) {
      dispatch(GlobalActions.setAlert({visible: false}))
    }
  }, [visible])

  useEffect(() => {
    if(loaded) {
      setVisible(alertSetting.visible)
    }
  }, [alertSetting])

  useEffect(() => {
    setLoaded(true)
  }, [])

  console.log()
  return (
    <ThemeProvider<Theme> theme={theme}>
      {
        visible &&
        <Box 
          className={classes.root} position={alertSetting.position || 'fixed'} 
          top={alertSetting.vertical == 'top' ? alertSetting.top || document.getElementsByTagName('header')[0].offsetHeight || 0 : 'initial'}
          bottom={alertSetting.vertical == 'bottom' ? alertSetting.bottom || 0 : 'initial'}
          >
            <Alert variant={alertSetting.variant || 'filled'} severity={alertSetting.severity} onClose={alertSetting.close ?  () => {
                if(typeof alertSetting.closeAction === 'function') {
                  alertSetting.closeAction()
                } else {
                  setVisible(false)
                }
              } : undefined} icon={alertSetting.Icon || undefined}>
              {
                typeof alertSetting.content === 'string' && <FormattedMessage id={alertSetting.content}/>
              }
              {
                typeof alertSetting.content === 'object' && alertSetting.content
              }
              {
                typeof alertSetting.content === 'function' && <alertSetting.content />
              }
            </Alert>
        </Box>
      }
    </ThemeProvider>
  );
}

export default LBAlert;
